export class Balance {
    balance: string;
    date_hour: string;
    init_balance: string;
    movs_balance: string;
    ops_balance: string;
    pos: string;
    profits: string;
    total: string;
    pendiente_2fa: boolean;
    cobro_servicio: string;
    ajuste_comision_compra: string;
    constructor({
        balance = '',
        date_hour = '',
        init_balance = '',
        movs_balance = '',
        ops_balance = '',
        pos = '',
        profits = '',
        total = '',
        pendiente_2fa = false,
        cobro_servicio = '',
        ajuste_comision_compra = ''
    }: any) {
        this.balance = balance;
        this.date_hour = date_hour;
        this.init_balance = init_balance;
        this.movs_balance = movs_balance;
        this.ops_balance = ops_balance;
        this.pos = pos;
        this.profits = profits;
        this.total = total;
        this.pendiente_2fa = pendiente_2fa;
        this.cobro_servicio = cobro_servicio;
        this.ajuste_comision_compra = ajuste_comision_compra;
    };
}